import React from 'react';
import "./StatusTokens.scss";

const StatusToken = (props) => {
	const { label, children, type } = props;
	return <div className={`status-token-outer${type ? " type-" + type : ""}`}><h5>{label || children}</h5></div>;
}

export default StatusToken;